import classNames from 'classnames'
import * as React from 'react'
import { JSX } from 'react'

import styles from './Text.module.scss'
import { TextAlign, TextColor, TextType, TextValign, TextWeight } from './types'

interface TextProps {
  align?: TextAlign
  valign?: TextValign
  left?: boolean
  center?: boolean
  right?: boolean
  as?: React.ElementType
  children: React.ReactNode
  className?: string
  color?: TextColor
  noWrap?: boolean
  type?: TextType
  uppercase?: boolean
  weight?: TextWeight
  inset?: boolean
  sfRounded?: boolean
  semibold?: boolean
  lightbold?: boolean
  bold?: boolean
  medium?: boolean
  pointer?: boolean
  onClick?(): void
  href?: string
}

export const Text = ({
  as: Component = 'div',
  children,
  type = 'body',
  // weight,
  // color,
  noWrap,
  align,
  valign,
  left,
  center,
  right,
  className,
  uppercase,
  // inset,
  // sfRounded,
  // semibold,
  // lightbold,
  // bold,
  // medium,
  pointer,
  ...rest
}: TextProps): JSX.Element => {
  let alignComputed = null

  if (left) {
    alignComputed = 'left'
  }

  if (center) {
    alignComputed = 'center'
  }

  if (right) {
    alignComputed = 'right'
  }

  if (align) {
    alignComputed = align
  }

  const classList = classNames(
    styles.root,
    type && styles[`typeface-${type}`],

    alignComputed && styles[`align-${alignComputed}`],
    valign && styles[`valign-${valign}`],
    // weight && styles[`weight-${weight}`],
    // semibold && styles['weight-semibold'],
    // lightbold && styles['weight-lightbold'],
    // bold && styles['weight-bold'],
    // medium && styles['weight-medium'],
    // color && styles[`color-${color}`],
    // sfRounded && styles.sfRounded,
    noWrap && styles.noWrap,
    uppercase && styles.uppercase,
    pointer && styles.pointer,
    className
  )

  return React.createElement(
    Component,
    { className: classList, ...rest },
    children
  )
}
